import React from 'react';

export const getIconStyle = (fill: React.CSSProperties['color'], style?: React.CSSProperties): React.CSSProperties => ({
  color: fill,
  ...style,
});
